import { useMemo } from 'react';

import type {
	FetchInput,
	FetchResponse,
	InviteInput,
	InviteResult,
	Product,
} from '@atlassian/expansion-services/services';
import { invite as inviteService } from '@atlassian/expansion-services/services';

import { useService } from '@confluence/expansion-services';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { ResolvedService, AbstractServiceMarker } from '@atlassian/expansion-services/types';

export const useInvite = (): ResolvedService<
	InviteInput,
	{
		createAnalyticsEvent: CreateUIAnalyticsEvent & AbstractServiceMarker;
		fetchJSON: (<Response>(input: FetchInput) => Promise<FetchResponse<Response>>) &
			AbstractServiceMarker;
		getCurrentCloudId: (() => string) & AbstractServiceMarker;
		getCurrentProduct: (() => Product) & AbstractServiceMarker;
		getCurrentUserId: (() => string) & AbstractServiceMarker;
		getStargateURL: (url: `/${string}`) => string;
	},
	Promise<InviteResult[]>
> => {
	const deps = useMemo(() => ({}), []);
	return useService(inviteService, deps);
};
